import SystemConfig, {CONFIG_PARAMS, MODES} from "../system/SystemConfig";
import {Container} from "inversify";
import IUIMessages from "./messages/IUIMessages";
import SERVICE_IDENTIFIER from "../constants/identifiers";
import UIMessages from "./messages/UIMessages";
import ButtonSounds from "./ButtonSounds";
import {PLATFORM} from "../system/SystemPlatform";
import IHwButtons from "./hwButtons/IHwButtons";
import BaseHwButtonsStates from "./hwButtons/BaseHwButtonsStates";
import MobileUI from "./mobile/MobileUI";
import IDOM from "./IDOM";
import MobileDOM from "./mobile/MobileDOM";
import IUIActions from "./IUIActions";
import MobileUIActions from "./mobile/MobileUIActions";
import AbstractStates from "../states/AbstractStates";
import MobileUIStates from "./mobile/MobileUIStates";
import UIController from "./UIController";
import MobileUIController from "./mobile/MobileUIController";
import ButtonsYouHoo from "./hwButtons/ButtonsYouHoo";
import VLTUI from "./vlt/VLTUI";
import VLTDOM from "./vlt/VLTDOM";
import VLTUIActions from "./vlt/VLTUIAction";
import VLTUIStates from "./vlt/VLTUIStates";
import VLTUIController from "./vlt/VLTUIController";
import DesktopUI from "./desktop/DesktopUI";
import DesktopDOM from "./desktop/DesktopDOM";
import DesktopUIActions from "./desktop/DesktopUIActions";
import DesktopUIStates from "./desktop/DesktopUIStates";
import DesktopUIController from "./desktop/DesktopUIController";
import AbstractUIScreen from "./screen/AbstractUIScreen";
import DesktopUIScreen from "./desktop/DesktopUIScreen";
import MobileUIScreen from "./mobile/MobileUIScreen";
import AbstractUI from "./AbstractUI";
import VLTUIScreen from "./vlt/VLTUIScreen";
import IBootConfig from "../boot/IBootConfig";
import VLT2UI from "./vlt2/VLT2UI";
import VLT2DOM from "./vlt2/VLT2DOM";
import VLT2UIStates from "./vlt2/VLT2UIStates";
import VLT2UIController from "./vlt2/VLT2UIController";
import VLT2UIScreen from "./vlt2/VLT2UIScreen";
import VLT2UIActions from "./vlt2/VLT2UIAction";
import AudioController from "./AudioController";
import PauseOverlay from "./components/PauseOverlay";
import AbstractUIActions from "./AbstractUIActions";
import platform = require('platform')
import LoadingScreen from "../loader/LoadingScreen";
import LoadingScreenNew from "../loader/LoadingScreenNew";

export function defineUI(container: Container, bootConfig: IBootConfig = {}) {

    let config = container.get<SystemConfig>(SERVICE_IDENTIFIER.SystemConfig);
    let ui_modes = config.get(CONFIG_PARAMS.UI_MODE);
    const brandName = config.get(CONFIG_PARAMS.BRAND_NAME);
    // TODO: desktop UI on mobile does not work

    if(config.get(CONFIG_PARAMS.BRAND_NAME)?.toLowerCase() === 'bellot'){
        container.bind<LoadingScreen>(SERVICE_IDENTIFIER.LoadingScreen)
    .toDynamicValue(() => {
        return new LoadingScreenNew();
    })
    .inSingletonScope();
    } else {
        container.bind<LoadingScreen>(SERVICE_IDENTIFIER.LoadingScreen).to(LoadingScreen).inSingletonScope();
    }

    document.body.setAttribute('data-brand', brandName?.toLowerCase()==='bellot' ? 'bellot' : '');

    let uiMessages = bootConfig.UIMessages ? bootConfig.UIMessages : UIMessages;
    container.bind<IUIMessages>(SERVICE_IDENTIFIER.UIMessages).to(uiMessages).inSingletonScope();
    let buttonSounds = bootConfig.ButtonSounds ? bootConfig.ButtonSounds : ButtonSounds;
    container.bind<ButtonSounds>(SERVICE_IDENTIFIER.ButtonSounds).to(buttonSounds).inSingletonScope();
    let audioController = bootConfig.AudioController ? bootConfig.AudioController : AudioController;
    container.bind<AudioController>(SERVICE_IDENTIFIER.AudioController).to(audioController).inSingletonScope();
    container.bind<PauseOverlay>(SERVICE_IDENTIFIER.PauseOverlay).to(PauseOverlay).inSingletonScope();

    if (config.platform.getPlatform() === PLATFORM.VLT) {
        config.set(CONFIG_PARAMS.UI_DEVICE, PLATFORM.VLT)
        if (config.get(CONFIG_PARAMS.EXHIBITION) == 2) {
            defineUIVLT2(container, bootConfig);
        } else {
            defineUIVLT(container, bootConfig);
        }
        return;
    }

    // By default, choose UI by platform
    let ui = config.platform.getPlatform();
    // If platform is in allowed ui_modes or ui_modes are not defined, select UI by platform
    // if (!ui_modes || !ui_modes[0] || ui_modes?.includes(config.platform.getPlatform())) {
    //     ui = config.platform.getPlatform();
    // }
    if (ui_modes && !ui_modes.includes(config.platform.getPlatform())) {
        // If platform is not allowed, use first allowed UI
        ui = ui_modes[0];
    }
    // If in Replay mode, set UI by url param replay_ui
    if (config.get(CONFIG_PARAMS.MODE) === MODES.REPLAY && config.get(CONFIG_PARAMS.REPLAY_UI)) {
        ui = config.get(CONFIG_PARAMS.REPLAY_UI);
    }
    switch(ui) {
        case PLATFORM.DESKTOP:
            config.set(CONFIG_PARAMS.UI_DEVICE, PLATFORM.DESKTOP)
            defineDesktop(container, bootConfig);
            break;
        case PLATFORM.MOBILE:
            config.set(CONFIG_PARAMS.UI_DEVICE, PLATFORM.MOBILE)
            defineUIMobile(container, bootConfig);
            break;
        default:
            console.error("Undefined ui: \"", ui, "\". Cannot continue.");
            break;
    }
}



function defineUIMobile(container: Container, bootConfig: IBootConfig) {
    container.bind<IHwButtons>(SERVICE_IDENTIFIER.HwButtonsStates).to(BaseHwButtonsStates).inSingletonScope();

    bindUI(
        container,
        {
            ui: bootConfig.MobileUI ? bootConfig.MobileUI : MobileUI,
            dom: bootConfig.MobileDOM ? bootConfig.MobileDOM : MobileDOM,
            actions: bootConfig.MobileUIActions ? bootConfig.MobileUIActions : MobileUIActions,
            states: bootConfig.MobileUIStates ? bootConfig.MobileUIStates : MobileUIStates,
            controller: bootConfig.MobileUIController ? bootConfig.MobileUIController : MobileUIController,
            screen: bootConfig.MobileUIScreen ? bootConfig.MobileUIScreen : MobileUIScreen,
        }
    )
}

function defineDesktop(container: Container, bootConfig: IBootConfig) {
    container.bind<IHwButtons>(SERVICE_IDENTIFIER.HwButtonsStates).to(BaseHwButtonsStates).inSingletonScope();

    bindUI(
        container,
        {
            ui: bootConfig.DesktopUI ? bootConfig.DesktopUI : DesktopUI,
            dom: bootConfig.DesktopDOM ? bootConfig.DesktopDOM : DesktopDOM,
            actions: bootConfig.DesktopUIActions ? bootConfig.DesktopUIActions : DesktopUIActions,
            states: bootConfig.DesktopUIStates ? bootConfig.DesktopUIStates : DesktopUIStates,
            controller: bootConfig.DesktopUIController ? bootConfig.DesktopUIController : DesktopUIController,
            screen: bootConfig.DesktopUIScreen ? bootConfig.DesktopUIScreen : DesktopUIScreen,
        }
    )
}

function defineUIVLT(container: Container, bootConfig: IBootConfig) {
    container.bind<IHwButtons>(SERVICE_IDENTIFIER.HwButtonsStates).to(ButtonsYouHoo).inSingletonScope();

    bindUI(
        container,
        {
            ui: bootConfig.VLTUI ? bootConfig.VLTUI : VLT2UI,
            dom: bootConfig.VLTDOM ? bootConfig.VLTDOM : VLT2DOM,
            actions: bootConfig.VLTUIActions ? bootConfig.VLTUIActions : VLT2UIActions,
            states: bootConfig.VLTUIStates ? bootConfig.VLTUIStates : VLT2UIStates,
            controller: bootConfig.VLTUIController ? bootConfig.VLTUIController : VLT2UIController,
            screen: bootConfig.VLTUIScreen ? bootConfig.VLTUIScreen : VLT2UIScreen,
        }
    )
}

function defineUIVLT2(container: Container, bootConfig: IBootConfig) {
    container.bind<IHwButtons>(SERVICE_IDENTIFIER.HwButtonsStates).to(ButtonsYouHoo).inSingletonScope();

    bindUI(
        container,
        {
            ui: bootConfig.VLT2UI ? bootConfig.VLT2UI : VLT2UI,
            dom: bootConfig.VLT2DOM ? bootConfig.VLT2DOM : VLT2DOM,
            actions: bootConfig.VLT2UIActions ? bootConfig.VLT2UIActions : VLT2UIActions,
            states: bootConfig.VLT2UIStates ? bootConfig.VLT2UIStates : VLT2UIStates,
            controller: bootConfig.VLT2UIController ? bootConfig.VLT2UIController : VLT2UIController,
            screen: bootConfig.VLT2UIScreen ? bootConfig.VLT2UIScreen : VLT2UIScreen,
        }
    )
}

function bindUI(container: Container, data: IUIData) {
    container.bind<AbstractUI>(SERVICE_IDENTIFIER.UI).to(data.ui).inSingletonScope();
    container.bind<IDOM>(SERVICE_IDENTIFIER.DOM).to(data.dom).inSingletonScope();
    container.bind<IUIActions>(SERVICE_IDENTIFIER.UIActions).to(data.actions).inSingletonScope();
    container.bind<AbstractStates>(SERVICE_IDENTIFIER.UIStates).to(data.states).inSingletonScope();
    container.bind<UIController>(SERVICE_IDENTIFIER.UIController).to(data.controller).inSingletonScope();
    container.bind<AbstractUIScreen>(SERVICE_IDENTIFIER.UIScreen).to(data.screen).inSingletonScope();
}

interface IUIData {
    ui: new (...args: any[]) => AbstractUI,
    dom: new (...args: any[]) => IDOM,
    actions: new (...args: any[]) => AbstractUIActions,
    states: new (...args: any[]) => AbstractStates,
    controller: new (...args: any[]) => UIController,
    screen: new (...args: any[]) => AbstractUIScreen
}
